import { ChangeEvent, useState } from 'react';

import { PCReleaseNoteList } from 'api';

const RN_PAGE_SIZE = 3;

export const usePagination = (
	releaseNotes: PCReleaseNoteList[],
	pageSize = RN_PAGE_SIZE
) => {
	const [originalReleaseNotes, setOriginalReleaseNotes] =
		useState(releaseNotes);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(
		Math.ceil(originalReleaseNotes.length / pageSize)
	);
	const [releaseNotesPage, setReleaseNotesPage] = useState(
		originalReleaseNotes.slice(page - 1, pageSize)
	);

	const handleChange = (_event: ChangeEvent<unknown>, value: number) => {
		setPage(value);
		const startIndex = (value - 1) * RN_PAGE_SIZE;
		setReleaseNotesPage(
			originalReleaseNotes.slice(startIndex, startIndex + RN_PAGE_SIZE)
		);
	};

	const updateReleaseNotes = (newReleaseNotes: PCReleaseNoteList[]) => {
		setPage(1);
		setCount(Math.ceil(newReleaseNotes.length / pageSize));
		setOriginalReleaseNotes(newReleaseNotes);
		setReleaseNotesPage(newReleaseNotes.slice(0, RN_PAGE_SIZE));
	};

	return {
		handleChange,
		count,
		page,
		releaseNotesPage,
		updateReleaseNotes,
	};
};
